import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    const t = localStorage.getItem("faitharama_token");
    if (!t) { setLoading(false); return; }
    try { const r = await api.get("/auth/me"); setUser(r.data); }
    catch (err) {
      // CRITICAL: ONLY remove the token on a REAL 401 (token expired or user
      // gone). Any other error (5xx, network timeout, CORS, etc.) leaves the
      // token alone — otherwise a single backend hiccup logs everyone out
      // mid-video. Mike was getting kicked back to /login every time
      // production rebooted. (Feb 2026 fix.)
      const status = err?.response?.status;
      if (status === 401 || status === 403) {
        localStorage.removeItem("faitharama_token");
      }
      // Don't set user — they'll show as logged-out for this page load, but
      // the next page navigation re-runs fetchMe and recovers automatically.
    }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchMe(); }, []);

  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    localStorage.setItem("faitharama_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const login = async (payload) => {
    const r = await api.post("/auth/login", payload);
    localStorage.setItem("faitharama_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => { localStorage.removeItem("faitharama_token"); setUser(null); };
  const refresh = fetchMe;

  return <AuthCtx.Provider value={{ user, loading, signup, login, logout, refresh }}>{children}</AuthCtx.Provider>;
}
